import type { ObservableValue } from '@amazon/vinyl-observable'
import { externalData } from '@amazon/vinyl-observable'
import { type RequesterImpl, RequestFailureType } from '@amazon/vinyl-util'
import { createDisposer, onLine, requesterWithRetryRef, type Unsubscribe } from '@amazon/vinyl-util'
import { isOnline } from '@/util/offlineUtil'

export function createGoodNetworkObservable(): ObservableValue<boolean> {
    return externalData(onLine(), (setData: (value: boolean) => void): Unsubscribe => {
        // Network is considered good or bad based on the last event of either a network request
        // completing, or the network online status changing.
        const { add, dispose } = createDisposer()
        const requester = requesterWithRetryRef.value as RequesterImpl
        add(
            requester.on('requestAttemptComplete', (event) => {
                if (!onLine()) return
                if (event.ok || event.type === RequestFailureType.INTERNAL) setData(event.ok)
            })
        )
        add(isOnline().onData(setData))
        return dispose
    })
}
